// General
import React from 'react';
import PropTypes from 'prop-types';

// Translation
import { injectIntl } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Button } from 'react-bootstrap';
import s from './IncrementButton.css';
import  { FaMinus, FaPlus } from 'react-icons/fa';

class IncrementButtonWeek extends React.Component {
  static propTypes = {
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    labelSingluar: PropTypes.string,
    labelPlural: PropTypes.string,
    incrementBy: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.any
  };

  increment = (value, maxValue, incrementBy) => {
    if (value * 7 < maxValue) {
      return ((Number(value) + Number(incrementBy)) * 7);
    }
  }

  decrement = (value, minValue, incrementBy) => {
    if (value * 7 > minValue) {
      return ((Number(value) - Number(incrementBy)) * 7);
    }
  }

  render() {

    const { input: { onChange }, maxValue, minValue, labelSingluar, labelPlural, incrementBy, isFeminin } = this.props;
    const { formatMessage } = this.props.intl;
    let {input: { value}} = this.props;
    let label;
    let adjustedValue = Math.round(value / 7);
    //Defaultvalue = minValue when not set
    if(!value) {
      value = minValue;
    }
    if (value > 1) {
      label = "Wochen";
    } else if(value === 1) {
      label = "Woche";
    } else  if(value === 0) {
      let prefix = isFeminin ? "Keine": "Kein";
      label = prefix + " " + labelSingluar
    }

    return (
      <div className={s.incrementDecrementButton}>
        <label className={s.incrementDecrementText}> {adjustedValue > 0 && adjustedValue} {label}</label>
        <Button className={s.iconButton} onClick={() => onChange(this.decrement(adjustedValue, minValue, incrementBy))}>
          <FaMinus />
        </Button>
        <Button className={s.iconButton} onClick={() => onChange(this.increment(adjustedValue, maxValue, incrementBy))}>
          <FaPlus />
        </Button>
      </div>
    )
  }
}

export default injectIntl(withStyles(s)(IncrementButtonWeek));
